import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';
import { format as dateFormat, parseISO } from 'date-fns';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { useGlobalComponent } from '@rhino-project/core/hooks';
export const CellTimeBase = ({
  format,
  empty = '-',
  ...props
}: TableInheritedProps & { format?: string; empty?: string }) => {
  const { locale } = useTranslation();
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const value = useMemo(() => {
    if (!getValue!()) return empty;

    return format
      ? dateFormat(parseISO(getValue!()), format)
      : new Intl.DateTimeFormat(locale.replaceAll('_', '-'), {
          timeStyle: 'short'
        }).format(parseISO(getValue!()));
  }, [empty, format, getValue, locale]);

  return <div {...inheritedProps}>{value}</div>;
};

export const CellTime = (props: TableInheritedProps) =>
  useGlobalComponent('CellTime', CellTimeBase, props);
